import { ICart } from "@features/cart/ICart";
import { EDataLayerEventType, sendEvent } from "./dataLayer";
import { getCartConfig, IDataLayerEcommerceItem, mapAddonListToItem, mapItems, mapOfferToItem } from "./cart";

export interface IDataLayerAddToCartEvent {
    event: EDataLayerEventType.ADD_TO_CART;
    ecommerce: {
        items: IDataLayerEcommerceItem[];
    };
    cartConfig: string;
}

export const sendAddOfferToCartEvent = (cart: ICart, offerId: number) => {
    const offer = cart.offers.find(({ offerId: id }) => id === offerId);

    if (!offer) {
        return;
    }

    sendEvent({
        event: EDataLayerEventType.ADD_TO_CART,
        ecommerce: {
            items: [mapOfferToItem(offer)],
        },
        cartConfig: getCartConfig(mapItems(cart.offers)),
    });
};

export const getLatestAddonAdded = (newCart: ICart, offerId: number) => {
    const addonList = newCart.offers.find(({ offerId: id }) => id === offerId)?.addOns;
    if (addonList) {
        return addonList[addonList.length - 1];
    }

    return undefined;
};

export const sendAddAddonToCartEvent = (cart: ICart, offerId: number) => {
    const addon = getLatestAddonAdded(cart, offerId);
    if (addon) {
        sendEvent({
            event: EDataLayerEventType.ADD_TO_CART,
            ecommerce: {
                items: [mapAddonListToItem([addon])],
            },
            cartConfig: getCartConfig(mapItems(cart.offers)),
        });
    }
};
